import css from './SingleEvent.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import { IEventPerformerRoleData } from 'meta/pages/v4/performer'
import { Routes } from 'meta/routes'
import { Dates } from 'utils/dates'

interface Props {
  list: IEventPerformerRoleData[]
  insideMulti?: boolean
  addTime?: boolean
}

const SingleEvent: React.FC<Props> = (props) => {
  const { list, addTime, insideMulti } = props

  const navigate = useNavigate()

  const { t } = useTranslation()

  const sortedList = addTime
    ? list.sort((a, b) => {
        if (a.time?.date_tz && b.time?.date_tz) {
          return new Date(a.time?.date_tz).getTime() - new Date(b.time?.date_tz).getTime()
        } else {
          return 0
        }
      })
    : list.sort((a, b) => a.name.localeCompare(b.name))

  return (
    <div className={classNames(css.singleEventContainer, { [css.insideMulti]: insideMulti })}>
      {sortedList.map((el, key) => {
        return (
          <div
            key={key}
            className={css.performer}
            onClick={() => {
              navigate(Routes.Performer.generatePath({ id: el.code }))
            }}
          >
            <div className={css.left}>
              <img className={css.image} alt={el.name} src={el.imageUrl} />
              <div className={css.name}>{el.name}</div>
            </div>

            <div className={css.right}>
              {addTime && (
                <div className={css.time}>
                  {el.time?.date_tz ? Dates.format(el.time?.date_tz, t('dates:common:hoursMinutes')) : '-'}
                </div>
              )}
              <div className={css.role}>{el.role ?? '-'}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SingleEvent
